import React from "react";
import {
  Clock,
  TrendingUp,
  Users,
  IndianRupee,
  CheckCircle2,
} from "lucide-react";

const WhyRetailMitra = () => {
  const cards = [
    {
      title: "2 hrs",
      subtitle: "saved daily",
      heading: "Save 2+ Hours Daily",
      detail:
        "No more manual calculations. Billing that took 2 minutes now takes 15 seconds.",
      bgColor: "bg-[#10b981]",
      icon: <Clock size={22} />,
    },
    {
      title: "30%",
      subtitle: "more sales",
      heading: "Increase Sales by 30%",
      detail:
        "Better stock management means no 'out of stock'. QR ordering means more orders.",
      bgColor: "bg-[#4f46e5]",
      icon: <TrendingUp size={22} />,
    },
    {
      title: "45%",
      subtitle: "retention up",
      heading: "More Repeat Customers",
      detail:
        "Track preferences, send offers, manage credit – customers keep coming back.",
      bgColor: "bg-[#f59e0b]",
      icon: <Users size={22} />,
    },
    {
      title: "₹5K+",
      subtitle: "saved monthly",
      heading: "Reduce Losses",
      detail:
        "Track every rupee. No more billing mistakes or inventory theft.",
      bgColor: "bg-[#c026d3]",
      icon: <IndianRupee size={22} />,
    },
  ];

  const benefits = [
    "Works on any Android phone",
    "No training needed – very simple",
    "Hindi & English support",
    "24/7 WhatsApp support",
    "Free data backup",
    "GST invoice ready",
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-14 items-center">

          {/* LEFT CONTENT */}
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-[#10b981] font-bold uppercase tracking-widest text-xs sm:text-sm mb-3">
              Why RetailMitra?
            </h2>

            <h3 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 mb-5 leading-tight">
              Built for Kirana Stores, <br />
              <span className="text-[#10b981]">By Kirana Experts</span>
            </h3>

            <p className="text-gray-500 text-sm sm:text-lg mb-8 max-w-xl mx-auto lg:mx-0">
              We spent 2 years talking to 500+ shop owners across India.
              RetailMitra solves the real problems you face every day.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="bg-emerald-50 p-1 rounded-full">
                    <CheckCircle2
                      className="text-[#10b981]"
                      size={16}
                    />
                  </div>
                  <span className="text-slate-700 text-sm sm:text-base font-medium">
                    {benefit}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT CONTENT – CARDS */}
          <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-5 w-full">
            {cards.map((card, index) => (
              <div
                key={index}
                className={`${card.bgColor} p-6 sm:p-8 rounded-3xl text-white shadow-xl transition-transform duration-300 sm:hover:scale-105`}
              >
                <div className="mb-5">{card.icon}</div>

                <div className="mb-3">
                  <span className="text-3xl sm:text-4xl font-black block leading-none">
                    {card.title}
                  </span>
                  <span className="text-[10px] sm:text-xs uppercase font-bold opacity-80">
                    {card.subtitle}
                  </span>
                </div>

                <h4 className="text-base sm:text-lg font-bold mb-2">
                  {card.heading}
                </h4>

                <p className="text-xs sm:text-sm leading-relaxed opacity-90">
                  {card.detail}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyRetailMitra;
